export default "__VITE_ASSET__679dfcc3__"